import React, { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import './change-request.css';
import { fetchChangeRequests, fetchChangeRequestById } from './store/slice';
import { actions as changeRequestActions } from './store/slice';
import { showToast } from '../../core/redux/toast/slice';
import ChangeRequestModals from './change-request-modals';
import ChangeRequestContent from './change-request-content';
import ChangeRequestTopHead from './change-request-top-head';
import { parseChangeRequestDeepLink } from './change-request-deep-link';

const { resetFilters, setFilterVisible } = changeRequestActions;

const ChangeRequestView = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const openedDeepLinkKeyRef = useRef(null);

  useEffect(() => {
    dispatch(fetchChangeRequests());
    return () => {
      dispatch(resetFilters());
      dispatch(setFilterVisible(false));
    };
  }, []);

  useEffect(() => {
    const deepLink = parseChangeRequestDeepLink(location.search);
    if (!deepLink) {
      openedDeepLinkKeyRef.current = null;
      return undefined;
    }

    const key = String(deepLink.changeRequestId);
    if (openedDeepLinkKeyRef.current === key) {
      return undefined;
    }

    dispatch(fetchChangeRequestById(deepLink.changeRequestId)).then(result => {
      if (result?.error) {
        dispatch(
          showToast({
            message: 'Could not open the change request from this notification.',
            type: 'warning',
          }),
        );
      }
    });
    openedDeepLinkKeyRef.current = key;
    return undefined;
  }, [dispatch, location.search]);

  return (
    <div>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header transfer">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>Change Request</h4>
                <h6>Manage Change Requests</h6>
              </div>
            </div>
            <ChangeRequestTopHead />
          </div>
          <ChangeRequestContent />
          <ChangeRequestModals />
        </div>
      </div>
    </div>
  );
};

export default ChangeRequestView;
